import axios from "../../plugins/axios";

export default {
    actions: {
        checkCashbackNumberAvailability(context, number) {
            return new Promise(((resolve, reject) => {
                axios
                    .post('/cashback_cards/is_unique_number', {number})
                    .then(response => {
                        context.commit('updateNumberAvailability', response.data['isAvailable'])
                        resolve()
                    })
                    .catch((reason) => {
                        reject(reason)
                    })
            }))
        },
        changeNumberAvailability(ctx) {
            ctx.commit('updateNumberAvailability', true)
        }
    },
    mutations: {
        updateNumberAvailability(state, model) {
            state.numberAvailability = model
        },
    },
    state: {
        numberAvailability: true,
    },
    getters: {
        isNumberAvailable(state) {
            return state.numberAvailability
        }
    },
}
